import Big from 'big.js'

/**
 * Compute CBAM liability in EUR using decimal math (Big.js) to avoid
 * IEEE-754 rounding. By default rounds to 2 decimal places for standard
 * currency display; pass a higher `fractionDigits` when the value is shown
 * with more precision (e.g. liability overview).
 * liability = netEmissions (tCO₂e) × pricePerTonne (€/tCO₂)
 */
export function computeCbamLiabilityEuro(
  netEmissions: number,
  pricePerTonne: number | string,
  fractionDigits: number = 2
): number {
  const emissions = new Big(netEmissions)
  const price = new Big(pricePerTonne)
  return emissions.times(price).round(fractionDigits, Big.roundHalfUp).toNumber()
}
